import { render, staticRenderFns } from "./UserViewModal.vue?vue&type=template&id=2522ef0d&scoped=true"
import script from "./UserViewModal.vue?vue&type=script&lang=js"
export * from "./UserViewModal.vue?vue&type=script&lang=js"
import style0 from "./UserViewModal.vue?vue&type=style&index=0&id=2522ef0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2522ef0d",
  null
  
)

export default component.exports